const defaultTimestep = (1 / 60) * 1000;
const getCurrentTime = typeof performance !== "undefined"
    ? () => performance.now()
    : () => Date.now();
const onNextFrame = typeof window !== "undefined"
    ? (callback) => window.requestAnimationFrame(callback)
    : (callback) => setTimeout(() => callback(getCurrentTime()), defaultTimestep);

export { defaultTimestep, onNextFrame };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framesync/dist/es/on-next-frame.mjs
// module id = w9fO
// module chunks = 0